import { PaginationState } from "@tanstack/react-table";
import { format } from "date-fns";
import { Field, Formik, Form } from "formik";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { SkeletonTheme } from "react-loading-skeleton";
import { useBlocker, useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import ModalButton from "../../shared/Ui/Buttons/ModalButtons";
import * as Yup from "yup";
import { EmptyListPlaceholderContent } from "../../shared/Ui/EmptyPageBlock";
import ModalComponent from "../../shared/Ui/ModalComponent/ModalWindow";
import SelectCustomFormik from "../../shared/Ui/SelectCustom/SelectCustomFormik";
import StatusBadge from "../../shared/Ui/StatusBadge/StatusBadge";
import ActionDropwdownCell from "../../shared/components/Table/ActionDropwdownCell";
import Pagination from "../../shared/components/Table/Pagination";
import { ITable } from "../../shared/components/Table/types";
import { useAppDispatch, useAppSelector } from "../../shared/hook";
import style from "./Ofd.module.css";
import InputMask from "react-input-mask";
import PageNotRole from "../../shared/Ui/PageNotFound/PageNotRole";
import Loader from "../../shared/Ui/Loader/Loader";
import SearchIcon from './../../../public/icons/icon-search.svg'
import CalendarSelectFormik from "../../shared/Ui/Calendar/ CalendarSelectFormik";
import { getCheck, getCheckList, getConsumerList, getOfdList } from "../../common/api/checkApi";
import { check } from "prettier";
import { FaRegCopy, FaExclamationCircle } from "react-icons/fa";
import { IoCheckmarkOutline } from "react-icons/io5";
import styles from "react-day-picker/dist/style.css";
import MockSkeletonDocs from "../Check/utils/MockSkeletonDocs";
import { clearBlocker, setBlocker } from "../../shared/slice/blockerSlice";
import AlertBox from "../../shared/Ui/AlertBox/AlertBox";
import CalendarSelect from "../../shared/Ui/Calendar/CalendarSelect";
import { getUserList, registerUser, RegistrationRequest } from "../../common/api/userCreateApi";
import { createOfd, updateOfd } from "../../common/api/ofdApi";
export type DocsType = "INBOX" | "SENT" | "DRAFT" | "PERSONALIZATION";

interface IDocumentType {
  type: DocsType;
}

interface StatusType {
  type: string;
  label: string;
}
interface OfdRequest {
  name: string;
  bin: string;
  pubKey: string;
  address: string;
  responsiblePerson: string;
  phoneNumber: number;
  webSite: string;
  disabled?: boolean;
  createdData?: Date;
}

interface LooseObject {
  [key: string]: any;
}
type IdType = number | string; // Определите тип данных для ID
type DocumentID = string | number; // Определяем тип для ID документов

export const OfdList: React.FC<any> = ({ type }) => {
  const tooltipRef = useRef<HTMLDivElement>(null);
  const [failedModal, setFailedModal] = useState<DocumentID[]>([]);
  const roleUser = useAppSelector((state) => state.auth.userData.role[0]);
  const [activeTooltipId, setActiveTooltipId] = useState<number | null>(null);
  const handleTooltipToggle = (id: number) => {
    setActiveTooltipId((prevId) => (prevId === id ? null : id));
  };
  const handleOutsideClick = (event: MouseEvent) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
      setActiveTooltipId(null);
    }
  };
  const [sort, setSort] = useState<"ASC" | "DESC">("DESC");
  const { t, i18n } = useTranslation();
  const [tableData, setTableData] = useState<any>();
  const pageSize = useAppSelector((state) => state.userSettings.pageSize);
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: pageSize,
  });
  const navigate = useNavigate();
  const [dataObject, setDataObject] = useState<any>({
    startDate: undefined, // Начальная дата по умолчанию
    startTime: "", // Время для начальной даты по умолчанию
    endDate: undefined, // Конечная дата по умолчанию
    endTime: "", // Время для конечной даты по умолчанию
  });
  const [copied, setCopied] = useState<boolean>(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState<boolean>(true);
  const [isModalOpen, setIsModalOpen] = useState<string | null>(null);
  const [errorModal, setErrorModal] = useState<any>(null);
  const onModalClose = () => setIsModalOpen(null);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();
  const [isComplexSearch, setIsComplexSearch] = useState(false);
  const [alertOpen, setAlertOpen] = useState<any>(null);
  const [checkModal, setCheckModal] = useState<any>(null);
  const [ofdEditModal, setOfdEditModal] = useState<any>(null)
  const [consumerList, setConsumerList] = useState([]);
  const [ofdListOptions, setOfdListOptions] = useState([]);
  const [isFormChanged, setIsFormChanged] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState({
    ofdId: null,
    receiver: null,
    consumerId: null,
    status: null,
    fromDateTime: null,
    toDateTime: null,
    searchTerm: '',
  });

  const [createOfdData, setCreateOfdData] = useState<any>({
    name: "",
    bin: "",
    publicKey: "",
    address: "",
    resp_person: "",
    phoneNumber: "",
    web: "",
  });
  
  const statusTypes: { [key: string]: StatusType } = {
    SENT: { type: "active", label: t("statusTypes.sent") }, // Зеленый
    ERROR: { type: "error", label: t("statusTypes.no_sent") }, // Красный
    SKIPPED: { type: "test", label: t("statusTypes.skipped") }, // Желтый
    REPROCESSING: { type: "processing", label: t("statusTypes.processing") }, // Голубой
  };

  // const formValidationSchema = () =>
  //   Yup.object().shape({
  //     searchTerm: Yup.string()
  //       .min(12, 'Минимум 12 символов')
  //       .max(30, "Максимум 30 символов"),
  //   });

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleCopied = () => {
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }

  const { isBlocked, proceed } = useAppSelector((state) => state.blocker);

  let blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isBlocked !== false && // и если форма изменена

      currentLocation.pathname !== nextLocation.pathname,
  );

  async function submitEdit(formikValues: any) {
    const backendData: OfdRequest = {
      bin: formikValues.bin !== ofdEditModal.bin ? formikValues.bin : null,
      pubKey: formikValues.publicKey !== ofdEditModal.publicKey ? formikValues.publicKey.replace(/\s+/g, '') : null,
      webSite: formikValues.web !== ofdEditModal.web ? formikValues.web : null,
      name: formikValues.name !== ofdEditModal.name ? formikValues.name : null,
      address: formikValues.address !== ofdEditModal.address ? formikValues.address : null,
      responsiblePerson: formikValues.resp_person !== ofdEditModal.resp_person ? formikValues.resp_person : null,
      phoneNumber: formikValues.phoneNumber !== ofdEditModal.phoneNumber ? formikValues.phoneNumber : null,
      disabled: formikValues.disabled !== ofdEditModal.disabled ? formikValues.disabled : null,
    };

    try {
      updateOfd(formikValues.id, backendData)
        .then((res) => {
          fetchOfds()
          setAlertOpen({
            status: "SUCCESS",
            message: "ОФД отредактирован",
          })
        })
    } catch (error: any) {
      setAlertOpen({
        status: "error",
        message: error.message,
      });
    }
    setOfdEditModal(null)
  }


  const fetchOfds = async (bin = '') => {
    try {
      getOfdList(bin, pagination.pageIndex + 1, pagination.pageSize)
        .then((response: any) => {
          setTableData(response)
        })

    } catch (error) {
      console.error(t("ofd.getData_error"), error);
    }
  };

  async function submitCreate(formikValues: any, resetForm: any) {
    const backendData: OfdRequest = {
      bin: formikValues.bin,
      pubKey: formikValues.publicKey.replace(/\s+/g, ''),
      webSite: formikValues.web,
      name: formikValues.name,
      address: formikValues.address,
      responsiblePerson: formikValues.resp_person,
      phoneNumber: formikValues.phoneNumber,
      disabled: false,
    };
    
    try {
      await createOfd(backendData);
      setAlertOpen({
        status: "SUCCESS",
        message: "ОФД успешно создан!",
      });
      resetForm();
      fetchOfds();
    } catch (error: any) {
      setAlertOpen({
        status: "error",
        message: error.response.data.message,
      });
    }
  }

  const formValidationSchema = () =>
    Yup.object().shape({
      bin: Yup.string()
        .required("Поле обязательно для заполнения")
        .min(12, 'Минимум 12 символов')
        .max(30, "Максимум 30 символов"),
      name: Yup.string()
        .required("Поле обязательно для заполнения"),
      address: Yup.string()
        .required("Поле обязательно для заполнения"),
      web: Yup.string()
        .required("Поле обязательно для заполнения"),
      publicKey: Yup.string()
        .required("Поле обязательно для заполнения"),
      resp_person: Yup.string()
        .required("Поле обязательно для заполнения"),
      phoneNumber: Yup.string()
        .required("Поле обязательно для заполнения")
        .test(
          "is-valid-phone",
          "Введите полный номер телефона",
          (value:any) => {
            return value && !value.includes("_");
          }
        ),
    });

  const minBinSchema = () =>
    Yup.object().shape({
      searchTerm: Yup.string()
        .min(12, 'Минимум 12 символов')
    });
console.log(123 , pagination);


  useEffect(() => {
    try {
      fetchOfds()
    } catch (error) {
      console.error(t("ofd.getData_error"), error);
    }
    getConsumerList()
      .then((response: any) => {
        const options =
          response &&
          response?.consumers?.map((item: any) => ({
            value: item.id,
            label: item.name,
          }));
        setConsumerList(options);
      })
  }, [pagination]);

  const renderActions = (
    value: any,
    setErrorModal: any,
    navigate: any,
    setAlertOpen?: any,
    setIsCheckOpen?: any,
  ) => {
    const actions = [];
    actions.push({
      title: value.disabled ? "Разблокировать" : "Заблокировать",
      action: async () => {
        await updateOfd(value?.id, {
          disabled: !value.disabled,
        });
        await fetchOfds()
        setActiveTooltipId(null)
      },
    }),
      actions.push({
        title: t("ofd.edit"),
        action: () => {
          setOfdEditModal({
            id: value.id,
            bin: value.bin,
            name: value.name,
            publicKey: value.pubKey,
            address: value.address,
            resp_person: value.responsiblePerson,
            phoneNumber: value.phoneNumber,
            web: value.webSite,
            status: value.disabled,
            disabled: value.disabled
          })
        }
      })
    {
      (value.status === "ERROR") &&
        (actions.push({
          title: t("checks.resend"),
          action: () => {
            console.log(123)
          }
        }))
    }
    return actions;
  };


  const calculateItemNumber = (index: any) => {
    return pagination.pageIndex * pagination.pageSize + index + 1;
  };


  const toggleSort = () => {
    const newSortDirection = sort === "ASC" ? "DESC" : "ASC";
    setSort(newSortDirection);
  };

  // if (!role && isLoadingRole) return <Loader />;

  // if (!role || !role?.view) {
  //   return (
  //     <PageNotRole />
  //   )
  // }

  return (
    <div className="flex flex-1 flex-col min-w-0">
      <h2 className="my-3 text-xl font-semibold">
        {t("ofd.ofdList")}
      </h2>

      <Formik
        initialValues={createOfdData}
        onSubmit={(formikValues, { resetForm }) => submitCreate(formikValues, resetForm)}
        enableReinitialize={true}
        validateOnBlur={true}
        validateOnChange={true}
        validationSchema={formValidationSchema}
      >
        {(formik) => {
          return (
            <Form
              className={`w-full mt-[20px] ${roleUser === 'ROLE_ADMIN' ? '' : 'hidden'}`}>
              {isBlocked && blocker.state === "blocked" ? (
                <ModalComponent
                  isOpen={true}
                  onClose={() => {
                    if (blocker && typeof blocker.reset === "function") {
                      blocker.reset();
                    } else {
                      console.error("Reset function is not available.");
                    }
                  }}
                  headerContent={
                    <>
                      <span>{t("notifications.modal_notification")}</span>
                      <button
                        type="button"
                        onClick={() => {
                          if (blocker && typeof blocker.reset === "function") {
                            blocker.reset();
                          } else {
                            console.error("Reset function is not available.");
                          }
                        }}
                        aria-label="Close"
                        className="float-right cursor-pointer bg-none border-none"
                      >
                        &times;
                      </button>
                    </>
                  }
                  content={<p>{t("notifications.unsaved_data")}</p>}
                  customContent={
                    <>
                      <ModalButton
                        type="button"
                        onClick={() => {
                          dispatch(clearBlocker());
                          if (blocker && typeof blocker.proceed === "function") {
                            blocker.proceed();
                          } else {
                            console.error("Proceed function is not available.");
                          }
                        }}
                      >
                        {t("mainButtons.cancel")}
                      </ModalButton>
                      <ModalButton
                        type="button"
                        color="green"
                        onClick={async () => {
                          dispatch(clearBlocker());
                          try {
                            await submitCreate(formik.values, formik.resetForm);
                            if (blocker && typeof blocker.proceed === "function") {
                              blocker.proceed();
                            }
                          } catch (error) {
                            console.error("Error saving data:", error);
                          }
                        }}
                      >
                        {t("mainButtons.save")}
                      </ModalButton>
                    </>
                  }
                />
              ) : null}
              <ModalComponent
                isOpen={errorModal}
                onClose={() => setErrorModal(null)}
                headerContent={t("notifications.modal_notification")}
                content={
                  <p>
                    {`${t("errors.errors_list")}: ${errorModal?.errorMessage ? errorModal?.errorMessage : "ошибка."}`}
                  </p>
                }
                customContent={
                  <ModalButton type="button" onClick={() => setErrorModal(null)}>
                    {t("mainButtons.accept")}
                  </ModalButton>
                }
              />
              {/* <ModalComponent
                                isOpen={userDelete !== null}
                                onClose={() => setUserDelete(null)}
                                headerContent={t("notifications.modal_notification")}
                                content={
                                    <p>
                                        {`Вы уверены что хотите удалить пользователя ${userDelete?.email}`}
                                    </p>
                                }
                                customContent={
                                    <>
                                        <ModalButton type="button" onClick={() => setUserDelete(null)}>
                                            {t("mainButtons.cancel")}
                                        </ModalButton>
                                        <ModalButton color="green" type="button" onClick={async () => {
                                            await deleteUser(userDelete?.userId); // Функция для удаления пользователя
                                            await fetchUsers();
                                            setUserDelete(null)
                                        }}>
                                            {t("mainButtons.accept")}
                                        </ModalButton>
                                    </>
                                }
                            /> */}

              <div className="flex flex-col bg-white p-5 pt-8 relative rounded-xl shadow-md gap-[20px] overflow-visible">
                <div
                  className="flex items-center text-base text-gray-600 font-light gap-x-[10px] cursor-pointer pb-[20px] border-b-[2px]"
                  onClick={() => setIsCreateModalOpen(!isCreateModalOpen)}
                >
                  <img src={"/icons/user-plus.svg"} className="w-[20px]" alt="icon" />
                  <div className="uppercase">{t("ofd.ofd_create")}</div>
                  <div className={`ml-auto transform transition-transform duration-300 ${isCreateModalOpen ? "rotate-180" : "rotate-0"}`}>
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                  </div>
                </div>

                <div className={`flex gap-[20px] flex-wrap ${isCreateModalOpen ? "hidden" : ""}`}>
                  <div className={`flex gap-[20px] w-full flex-wrap`}>
                    <div className={style.inputField1}>
                      <div className={style.labelAndButtonWrapper}>
                        <label className={style.inputLabel}>
                          {t("ofd.name_ofd")}*
                        </label>
                        {formik.touched.name &&
                          formik.errors.name && (
                            <div className={style.tooltipWrapper}>
                              <FaExclamationCircle className={style.errorIcon} />
                              <div className={style.tooltipText}>
                                {typeof formik.errors.name ===
                                  "string"
                                  ? formik.errors.name
                                  : t(
                                    "Ошибка",
                                  )}
                              </div>
                            </div>
                          )}
                      </div>
                      <Field
                        type="text"
                        name="name"
                        placeholder={t("Введите наименование ОФД")}
                        className={style.placeholder}
                        onChange={(e: any) => {
                          formik.handleChange(e);
                          // dispatch(setBlocker(true));
                          setIsFormChanged(true);
                        }}
                      />
                    </div>

                    <div className={style.inputField1}>
                      <div className={style.labelAndButtonWrapper}>
                        <label className={style.inputLabel}>
                          {t("ofd.bin_ofd")}*
                        </label>
                        {formik.touched.bin &&
                          formik.errors.bin && (
                            <div className={style.tooltipWrapper}>
                              <FaExclamationCircle className={style.errorIcon} />
                              <div className={style.tooltipText}>
                                {typeof formik.errors.bin ===
                                  "string"
                                  ? formik.errors.bin
                                  : t(
                                    "Ошибка",
                                  )}
                              </div>
                            </div>
                          )}
                      </div>
                      <Field
                        type="number"
                        name="bin"
                        placeholder={t("Введите БИН ОФД")}
                        className={style.placeholder}
                        onChange={(e: any) => {
                          let value = e.target.value;
                          if (value.length > 12) {
                            value = value.slice(0, 12); // Ограничиваем длину до 12 символов
                            e.target.value = value;
                          }
                          formik.handleChange(e);
                          // dispatch(setBlocker(true));
                          setIsFormChanged(true);
                        }}
                      />
                    </div>

                    <div className={style.inputField1}>
                      <div className={style.labelAndButtonWrapper}>
                        <label className={style.inputLabel}>
                          {t("ofd.address")}*
                        </label>
                        {formik.touched.address &&
                          formik.errors.address && (
                            <div className={style.tooltipWrapper}>
                              <FaExclamationCircle className={style.errorIcon} />
                              <div className={style.tooltipText}>
                                {typeof formik.errors.address ===
                                  "string"
                                  ? formik.errors.address
                                  : t(
                                    "Ошибка",
                                  )}
                              </div>
                            </div>
                          )}
                      </div>
                      <div className="relative flex items-center">
                        <Field
                          type="text"// Меняем тип на 'text', если показываем пароль
                          name="address"
                          placeholder="Введите адрес"
                          className={style.placeholder} // Ваш класс для стилей
                          onChange={(e: any) => {
                            formik.handleChange(e);
                            // dispatch(setBlocker(true));
                            setIsFormChanged(true);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.inputField1} ${style.fullWidth}`}>
                    <div className={style.labelAndButtonWrapper}>
                      <label className={style.inputLabel}>
                        {t("ofd.publicKey")}*
                      </label>
                      {formik.touched.publicKey &&
                        formik.errors.publicKey && (
                          <div className={style.tooltipWrapper}>
                            <FaExclamationCircle className={style.errorIcon} />
                            <div className={style.tooltipText}>
                              {typeof formik.errors.publicKey ===
                                "string"
                                ? formik.errors.publicKey
                                : t(
                                  "Ошибка",
                                )}
                            </div>
                          </div>
                        )}
                    </div>
                    <Field
                      as="textarea"
                      name="publicKey"
                      placeholder={t("Введите публичный ключ")}
                      className={style.placeholder2}
                      onChange={(e: any) => {
                        formik.handleChange(e);
                        // dispatch(setBlocker(true));
                        setIsFormChanged(true);
                      }}
                      onKeyDown={(e: React.KeyboardEvent) => {
                        // Запрещаем пробелы и Enter
                        if (e.key === " " || e.key === "Enter") {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>

                  <div className={`flex gap-[20px] w-[66%] flex-wrap`}>
                    <div className={style.inputField2}>
                      <div className={style.labelAndButtonWrapper}>
                        <label className={style.inputLabel}>
                          {t("ofd.resp_person")}*
                        </label>
                        {formik.touched.resp_person &&
                          formik.errors.resp_person && (
                            <div className={style.tooltipWrapper}>
                              <FaExclamationCircle className={style.errorIcon} />
                              <div className={style.tooltipText}>
                                {typeof formik.errors.resp_person ===
                                  "string"
                                  ? formik.errors.resp_person
                                  : t(
                                    "Ошибка",
                                  )}
                              </div>
                            </div>
                          )}
                      </div>
                      <div className="relative flex items-center">
                        <Field
                          type="text"// Меняем тип на 'text', если показываем пароль
                          name="resp_person"
                          placeholder="Введите ответственное лицо"
                          className="placeholder" // Ваш класс для стилей
                          onChange={(e: any) => {
                            formik.handleChange(e);
                            // dispatch(setBlocker(true));
                            setIsFormChanged(true);
                          }}
                        />
                      </div>
                    </div>

                    <div className={`${style.inputField2}`}>
                      <div className={style.labelAndButtonWrapper}>
                        <label className={style.inputLabel}>
                          {t("ofd.contacts")}*
                        </label>
                        {formik.touched.phoneNumber &&
                          formik.errors.phoneNumber && (
                            <div className={style.tooltipWrapper}>
                              <FaExclamationCircle className={style.errorIcon} />
                              <div className={style.tooltipText}>
                                {typeof formik.errors.phoneNumber ===
                                  "string"
                                  ? formik.errors.phoneNumber
                                  : t(
                                    "notification_from_third_countries.error_customs_clearance_reg_date",
                                  )}
                              </div>
                            </div>
                          )}
                      </div>
                      <InputMask
                        mask="+7 (999) 999-99-99"
                        maskChar="_"
                        type="text"
                        name="phoneNumber"
                        placeholder={t("+7 (___) ___-__-__")}
                        className={style.placeholder}
                        value={formik.values.phoneNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </div>

                    <div className={`${style.inputField2} max-w-[33%]`}>
                      <div className={style.labelAndButtonWrapper}>
                        <label className={style.inputLabel}>
                          {t("ofd.web")}*
                        </label>
                        {formik.touched.web &&
                          formik.errors.web && (
                            <div className={style.tooltipWrapper}>
                              <FaExclamationCircle className={style.errorIcon} />
                              <div className={style.tooltipText}>
                                {typeof formik.errors.web ===
                                  "string"
                                  ? formik.errors.web
                                  : t(
                                    "notification_from_third_countries.error_customs_clearance_reg_date",
                                  )}
                              </div>
                            </div>
                          )}
                      </div>
                      <Field
                        type="text"
                        name="web"
                        placeholder={t("Введите веб-сайт")}
                        isMulti={false}
                      />
                    </div>
                    <div className="ml-auto items-center mt-[10px] flex gap-[10px]">
                      <button
                        type="button"
                        className="bg-bg w-auto text-gray-500 font-semibold py-2 px-4 h-[40px] rounded hover:brightness-75  whitespace-nowrap"
                        onClick={() => {
                          formik.resetForm()
                        }}
                      >
                        {t("Отменить")}
                      </button>
                      <button
                        className="buttonEtrackc h-[40px] w-[200px] bg-mainColor hover:brightness-75 text-white font-bold py-2 px-4 rounded"
                        type="submit"
                        onClick={() => console.log(678, formik.values)}
                      >
                        {t("Создать")}
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </Form>
          );
        }}
      </Formik>

      <div className="bg-white w-full  my-5 p-5  pt-8 relative rounded-xl shadow-md flex flex-wrap flex-row align-center gap-[20px]">
        <Formik
          initialValues={initialValues}
          onSubmit={() => {
            setPagination((prevValues: PaginationState) => {
              return { ...prevValues, pageIndex: 0 };
            });
          }}
          // enableReinitialize={true}
          validateOnBlur={true}
          validateOnChange={true}
          validationSchema={minBinSchema}

        >
          {(formik) => (
            <Form className="w-full">
              <div className="flex flex-1 justify-between">
                <div className="flex flex-row w-full gap-[10px]">

                  <div className="relative w-full max-w-[500px]">

                    <div className="flex flex-col gap-1">
                      {formik.touched.searchTerm && formik.errors.searchTerm && (
                        <div className={style.tooltipWrapper22}>
                          <FaExclamationCircle className={style.errorIcon} />
                          <div className={style.tooltipText}>
                            {typeof formik.errors.searchTerm === "string"
                              ? formik.errors.searchTerm
                              : t("checks.error")}
                          </div>
                        </div>
                      )}
                      <div className="flex justify-between items-center">
                      </div>
                      <div className="relative">
                        <img
                          src="/icons/icon-search.svg"
                          alt="Search"
                          className="absolute left-2 top-1/2 transform -translate-y-1/2 w-5 h-5"
                        />
                        <Field
                          type="text"
                          name="searchTerm"
                          placeholder={t("Введите БИН ОФД")}
                          maxLength={12}
                          className="w-full h-10 border border-mainColor rounded-lg pl-9 text-[#2e3138] outline-none"
                          onChange={(e: any) => {
                            formik.handleChange(e);
                            setInitialValues((prevValues: any) => ({
                              ...prevValues,
                              searchTerm: e.target.value,
                            }));
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="bg-mainColor text-white font-semibold mt-[4px] py-2 px-4 h-[40px] rounded whitespace-nowrap"
                    onClick={() => fetchOfds(formik.values.searchTerm.trim().replace(/\s+/g, ' '))}
                  >
                    {t("ofd.search")}
                  </button>
                  <button
                    type="button"
                    className="bg-bg text-gray-500 font-semibold mt-[4px] py-2 px-4 h-[40px] rounded whitespace-nowrap"
                    onClick={() => {
                      formik.setFieldValue("searchTerm", ""); // Сбрасываем поиск
                      fetchOfds(""); // Очищаем результаты
                    }}
                  >
                    {t("Сбросить")}
                  </button>

                </div>

                <div className="flex justify-between flex-row gap-[10px]">
                  <button
                    type="button"
                    className="bg-bg text-gray-500 font-semibold mt-[4px] py-2 px-4 h-[40px] rounded whitespace-nowrap"

                    onClick={() => {
                      setInitialValues({
                        ofdId: null,
                        receiver: null,
                        consumerId: null,
                        status: null,
                        fromDateTime: null,
                        toDateTime: null,
                        searchTerm: ''
                      });
                      formik.resetForm({
                        values: {
                          ofdId: null,
                          receiver: null,
                          consumerId: null,
                          status: null,
                          fromDateTime: null,
                          toDateTime: null,
                          searchTerm: ''
                        },
                      });
                      setDataObject({
                        startDate: undefined, // Начальная дата по умолчанию
                        startTime: "", // Время для начальной даты по умолчанию
                        endDate: undefined, // Конечная дата по умолчанию
                        endTime: "",
                      })
                      setPagination((prevValues: PaginationState) => {
                        return { ...prevValues, pageIndex: 0 };
                      });
                      // setIsFilterOpen(false);
                    }}
                  >
                    {t("ofd.refresh")}
                  </button>

                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>

      <div className="w-full">
        <div className="rounded-lg overflow-x-auto bg-white">
          <table className="max-w-full w-full leading-normal">
            <thead className="border-b-2 border-gray-300">
              <tr>

                <th className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                  scope="col">
                  {/* <CheckBox
                      id="mainCheckbox"
                      checked={
                        deleteArray?.length === tableData?.values?.length ||
                        downloadArray?.length === tableData?.values?.length
                      }
                     
                    /> */}
                  {t("ofd.number")}
                </th>

                <th
                  className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                  scope="col"
                >
                  {t("ofd.name_ofd")}
                </th>
                <th
                  className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                  scope="col"
                >
                  {t("ofd.bin_ofd")}
                </th>
                <th
                  className="px-5 py-3 text-center items-center text-gray-600 font-semibold bg-white border-b border-gray-200 flex justify-center"
                  scope="col"
                >
                  {t("ofd.add_date")}
                  <div className="flex flex-col">
                    <button className="h-6 w-6" onClick={toggleSort}>
                      <img
                        src={`/icons/arrow${sort === "ASC" ? "Down2" : "-top"}.svg`}
                        className={`block h-6 w-6  ${sort === "ASC" ? "text-red-500" : ""}`}
                        alt={sort === "ASC" ? "Ascending" : "Descending"}
                      />
                    </button>
                  </div>
                </th>
                <th
                  className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                  scope="col"
                >
                  {t("ofd.status")}
                </th>
                <th
                  className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                  scope="col"
                >
                  {t("ofd.address")}
                </th>
                <th
                  className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                  scope="col"
                >
                  {t("ofd.web")}
                </th>
                <th
                  className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                  scope="col"
                >
                  {t("ofd.resp_person")}
                </th>
                <th
                  className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                  scope="col"
                >
                  {t("ofd.contacts")}
                </th>
                <th
                  className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                  scope="col"
                >
                  {t("")}
                </th>
              </tr>
            </thead>
            {isLoading ? (
              <SkeletonTheme baseColor="#ebebeb" highlightColor="#c9c9c9">
                <tbody className="font-normal text-center">
                  {new Array(10).fill(1).map((_, index) => (
                    <MockSkeletonDocs key={index} index={index} />
                  ))}
                </tbody>
              </SkeletonTheme>
            ) : !tableData?.ofds[0] ? (
              <tbody>
                <tr>
                  <td colSpan={9} className="text-center py-5">
                    <div>
                      <EmptyListPlaceholderContent
                        title={t("ofd.not_found")}
                        description={t("ofd.update_page")}
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody className="font-normal text-center">
                {tableData?.ofds[0] && tableData?.ofds?.map((value: any, index: any) => (
                  <>
                    <tr
                      key={`tr-${index}-${value.id}`}
                      className="cursor-pointer hover:bg-gray-100"
                      onClick={() => {
                      }}
                    >

                      <td className="px-5 py-5 text-sm  border-b border-gray-200 text-gray-600">
                        {/* <CheckBox
                          id={`checkBox${index}`}
                          checked={deleteArray.includes(value.id) || downloadArray.includes(value.id)}
                          // onChange={() => handleCheckboxChange(value.id)}
                        /> */}
                        {calculateItemNumber(index) || "-"}
                      </td>

                      <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                        {value?.name || "-"}
                      </td>
                      <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                        {value?.bin || "-"}
                      </td>
                      <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                        {value?.createdDate &&
                          format(value?.createdDate, "dd.MM.yyyy, HH:mm:ss") ||
                          "-"}
                      </td>
                      <td className="flex px-5 py-5 text-sm border-b border-gray-200 justify-center text-gray-600 text-center w-[225px]">
                        {value?.disabled != null ? (
                          !value.disabled ? (
                            <div className="flex justify-center">
                              <StatusBadge type="active">
                                {t("statusTypes.active")}
                              </StatusBadge>
                            </div>
                          ) : (
                            <>
                              <StatusBadge>
                                {t("statusTypes.not_active")}
                              </StatusBadge>
                            </>
                          )
                        ) : (
                          "-"
                        )}
                      </td>
                      <td className={style.customTd}
                        data-tooltip-id={`tooltip-address-${value?.id}`}>
                        <div className="overflow-hidden text-overflow-ellipsis">
                          {value?.address || "-"}
                        </div>
                        <Tooltip
                          id={`tooltip-address-${value?.id}`}
                          place="top"
                          clickable={true}
                          className={style.customTooltip}
                        >
                          <div className="flex flex-col">
                            <p style={{ margin: "8px 0 0" }}>
                              {value?.address || t("checks.no_address")}
                            </p>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                navigator.clipboard.writeText(value?.note || '');
                                handleCopied()
                              }}
                              className="self-center bg-transparent text-gray-400 font-bold py-1 px-3 rounded cursor-pointer flex items-center gap-1 mt-1"
                            >
                              {copied ? (
                                <>
                                  <IoCheckmarkOutline />
                                  Скопировано!
                                </>
                              ) : (
                                <>
                                  <FaRegCopy />
                                  Копировать
                                </>
                              )}
                            </button>
                          </div>
                        </Tooltip>
                      </td>
                      <td className="px-5 py-5 text-sm  border-b border-gray-200 text-gray-600">
                        {value?.webSite ||
                          "-"}
                      </td>

                      <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                        {value?.responsiblePerson || "-"}
                      </td>
                      <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                        {value?.phoneNumber || "-"}
                      </td>
                      <td className="px-5 py-5 text-sm  border-b border-gray-200 text-gray-600"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <ActionDropwdownCell
                          key={`cell-${index}-${value.id}-actions`}
                          id={value.id}
                          actions={renderActions(
                            value,
                            setErrorModal,
                            navigate,
                          )}
                          activeTooltipId={activeTooltipId}
                          onTooltipToggle={handleTooltipToggle}
                          tooltipRef={tooltipRef}
                        />
                      </td>
                    </tr>

                  </>
                ))}
              </tbody>
            )}
          </table>
        </div>
        <Pagination
          totalItems={tableData?.totalItems || 0}
          totalPages={tableData?.totalPages || 0}
          pagination={pagination}
          setPagination={setPagination}
        />
      </div>

      <ModalComponent
        isOpen={!!isModalOpen}
        onClose={onModalClose}
        headerContent={
          <h1 className="h__modal">{t("documentNotification.notification")}</h1>
        }
        content={
          <p className="p__modal">
            {t("documentLabels_3.confirm_delete")}
            {Array.isArray(isModalOpen) && isModalOpen?.length > 1
              ? t("documentLabels_3.selected_documents")
              : t("documentLabels_3.selected_document")}
            ?
          </p>
        }
        customContent={
          <div className="flex flex-row gap-[10px]">
            <ModalButton
              type="button"
              color="grey"
              onClick={() => {
                setIsModalOpen(null);
              }}
            >
              {t("mainButtons.cancel")}
            </ModalButton>
            <ModalButton
              // color="green"
              type="button"
              onClick={async () => {
                if (isModalOpen) {

                }
              }}
            >
              {t("mainButtons.delete")}
            </ModalButton>
          </div>
        }
      />
      {ofdEditModal ? (
        <ModalComponent
          isOpen={true}
          onClose={() => {
            setOfdEditModal(null)
          }}
          headerContent={
            <div className="flex justify-between">
              <div className="flex items-center text-base text-gray-600 font-light gap-x-[10px] ">
                <img src={"/icons/user-plus.svg"} className="w-[20px]" alt="icon" />
                <div className="uppercase">{t("Редактирование ОФД")}</div>
              </div>
              <button
                type="button"
                onClick={() => {
                  setOfdEditModal(null)
                }}
                aria-label="Close"
                className="float-right cursor-pointer bg-none border-none"
              >
                &times;
              </button>
            </div>
          }
          content={
            <>
              <Formik
                initialValues={ofdEditModal}
                onSubmit={(formikValues) => submitEdit(formikValues)}
                enableReinitialize={true}
                validateOnBlur={true}
                validateOnChange={true}
                validationSchema={formValidationSchema()}
              >
                {(formik) => {
                  return (
                    <Form className=" w-full m-t-[20px]">
                      <div className="flex flex-col bg-white my-5 p-5 pl-0 pr-0 pt-8 relative rounded-xl gap-[20px] overflow-visible">

                        <div className={`flex gap-[20px] items-center flex-wrap`}>
                          <div className={style.inputField1}>
                            <div className={style.labelAndButtonWrapper}>
                              <label className={style.inputLabel}>
                                {t("ofd.name_ofd")}
                              </label>
                              {formik.touched.name &&
                                formik.errors.name && (
                                  <div className={style.tooltipWrapper}>
                                    <FaExclamationCircle className={style.errorIcon} />
                                    <div className={style.tooltipText}>
                                      {typeof formik.errors.name ===
                                        "string"
                                        ? formik.errors.name
                                        : t(
                                          "Ошибка",
                                        )}
                                    </div>
                                  </div>
                                )}
                            </div>
                            <Field
                              type="text"
                              name="name"
                              placeholder={t("Введите имя")}
                              className={style.placeholder}
                              onChange={(e: any) => {
                                formik.handleChange(e);
                                // dispatch(setBlocker(true));
                                setIsFormChanged(true);
                              }}
                            />
                          </div>

                          <div className={`${style.inputField1} max-w-[calc(50%-10px)]`}>
                            <div className={style.labelAndButtonWrapper}>
                              <label className={style.inputLabel}>
                                {t("Статус")}
                              </label>
                              {formik.touched.disabled &&
                                formik.errors.disabled && (
                                  <div className={style.tooltipWrapper}>
                                    <FaExclamationCircle className={style.errorIcon} />
                                    <div className={style.tooltipText}>
                                      {typeof formik.errors.disabled ===
                                        "string"
                                        ? formik.errors.disabled
                                        : t(
                                          "notification_from_third_countries.error_customs_clearance_reg_date",
                                        )}
                                    </div>
                                  </div>
                                )}
                            </div>
                            <Field
                              component={SelectCustomFormik}
                              name="disabled"
                              placeholder={t("Выберите статус")}
                              options={[
                                { value: true, label: 'Заблокирован' },
                                { value: false, label: 'Активный' },
                              ]}
                              isMulti={false}
                              menuPlacement="top"
                            />
                          </div>

                          <div className={`${style.inputField1} ${style.fullWidthModal}`}>
                            <div className={style.labelAndButtonWrapper}>
                              <label className={style.inputLabel}>
                                {t("ofd.publicKey")}
                              </label>
                              {formik.touched.publicKey &&
                                formik.errors.publicKey && (
                                  <div className={style.tooltipWrapper}>
                                    <FaExclamationCircle className={style.errorIcon} />
                                    <div className={style.tooltipText}>
                                      {typeof formik.errors.publicKey ===
                                        "string"
                                        ? formik.errors.publicKey
                                        : t(
                                          "Ошибка",
                                        )}
                                    </div>
                                  </div>
                                )}
                            </div>
                            <Field
                              as="textarea"
                              name="publicKey"
                              placeholder={t("Введите публичный ключ")}
                              className={style.placeholder2}
                              onChange={(e: any) => {
                                formik.handleChange(e);
                                // dispatch(setBlocker(true));
                                setIsFormChanged(true);
                              }}
                              onKeyDown={(e: React.KeyboardEvent) => {
                                // Запрещаем пробелы и Enter
                                if (e.key === " " || e.key === "Enter") {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </div>

                          <div className={`${style.inputField1} ${style.fullWidth}`}>
                            <div className={style.labelAndButtonWrapper}>
                              <label className={style.inputLabel}>
                                {t("ofd.address")}
                              </label>
                              {formik.touched.address &&
                                formik.errors.address && (
                                  <div className={style.tooltipWrapper}>
                                    <FaExclamationCircle className={style.errorIcon} />
                                    <div className={style.tooltipText}>
                                      {typeof formik.errors.address ===
                                        "string"
                                        ? formik.errors.address
                                        : t(
                                          "Ошибка",
                                        )}
                                    </div>
                                  </div>
                                )}
                            </div>
                            <div className="relative flex items-center">
                              <Field
                                type="text"
                                name="address"
                                placeholder="Введите адрес"
                                className="placeholder" // Ваш класс для стилей
                                onChange={(e: any) => {
                                  formik.handleChange(e);
                                  // dispatch(setBlocker(true));
                                  setIsFormChanged(true);
                                }}
                              />
                            </div>
                          </div>

                          <div className={style.inputField1}>
                            <div className={style.labelAndButtonWrapper}>
                              <label className={style.inputLabel}>
                                {t("ofd.resp_person")}
                              </label>
                              {formik.touched.resp_person &&
                                formik.errors.resp_person && (
                                  <div className={style.tooltipWrapper}>
                                    <FaExclamationCircle className={style.errorIcon} />
                                    <div className={style.tooltipText}>
                                      {typeof formik.errors.resp_person ===
                                        "string"
                                        ? formik.errors.resp_person
                                        : t(
                                          "Ошибка",
                                        )}
                                    </div>
                                  </div>
                                )}
                            </div>
                            <div className="relative flex items-center">
                              <Field
                                type="text"
                                name="resp_person"
                                placeholder="Введите ответственное лицо"
                                className="placeholder" // Ваш класс для стилей
                                onChange={(e: any) => {
                                  formik.handleChange(e);
                                  // dispatch(setBlocker(true));
                                  setIsFormChanged(true);
                                }}
                              />
                            </div>
                          </div>

                          <div className={style.inputField1}>
                            <div className={style.labelAndButtonWrapper}>
                              <label className={style.inputLabel}>
                                {t("ofd.contacts")}
                              </label>
                              {formik.touched.phoneNumber &&
                                formik.errors.phoneNumber && (
                                  <div className={style.tooltipWrapper}>
                                    <FaExclamationCircle className={style.errorIcon} />
                                    <div className={style.tooltipText}>
                                      {typeof formik.errors.phoneNumber ===
                                        "string"
                                        ? formik.errors.phoneNumber
                                        : t(
                                          "notification_from_third_countries.error_customs_clearance_reg_date",
                                        )}
                                    </div>
                                  </div>
                                )}
                            </div>
                            <InputMask
                              mask="+7 (999) 999-99-99"
                              maskChar="_"
                              type="text"
                              name="phoneNumber"
                              placeholder={t("Введите телефон")}
                              className={style.placeholder}
                              value={formik.values.phoneNumber}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                          </div>

                          <div className={`${style.inputField1} ${style.fullWidth}`}>
                            <div className={style.labelAndButtonWrapper}>
                              <label className={style.inputLabel}>
                                {t("ofd.web")}
                              </label>
                              {formik.touched.web &&
                                formik.errors.web && (
                                  <div className={style.tooltipWrapper}>
                                    <FaExclamationCircle className={style.errorIcon} />
                                    <div className={style.tooltipText}>
                                      {typeof formik.errors.web ===
                                        "string"
                                        ? formik.errors.web
                                        : t(
                                          "notification_from_third_countries.error_customs_clearance_reg_date",
                                        )}
                                    </div>
                                  </div>
                                )}
                            </div>
                            <Field
                              type="text"
                              name="web"
                              placeholder={t("Введите веб-сайт")}
                              isMulti={false}
                            />
                          </div>

                          <div className={style.inputField1}>
                            <div className={style.labelAndButtonWrapper}>
                              <label className={style.inputLabel}>
                                {t("ofd.bin_ofd")}
                              </label>
                              {formik.touched.bin &&
                                formik.errors.bin && (
                                  <div className={style.tooltipWrapper}>
                                    <FaExclamationCircle className={style.errorIcon} />
                                    <div className={style.tooltipText}>
                                      {typeof formik.errors.bin ===
                                        "string"
                                        ? formik.errors.bin
                                        : t(
                                          "Ошибка",
                                        )}
                                    </div>
                                  </div>
                                )}
                            </div>
                            <Field
                              type="text"
                              name="bin"
                              disabled={true}
                              placeholder={t("Введите БИН")}
                              className={style.placeholder}
                              onChange={(e: any) => {
                                formik.handleChange(e);
                                // dispatch(setBlocker(true));
                                setIsFormChanged(true);
                              }}
                            />
                          </div>
                          <div className="flex justify-end ml-[40px] mt-[10px] max-h-[40px] gap-[10px]">
                            <ModalButton
                              type="button"
                              onClick={() => {
                                dispatch(clearBlocker());
                                if (blocker && typeof blocker.proceed === "function") {
                                  blocker.proceed();
                                } else {
                                  console.error("Proceed function is not available.");
                                }
                                setOfdEditModal(null)
                              }}
                            >
                              {t("mainButtons.cancel")}
                            </ModalButton>
                            <ModalButton
                              type="submit"
                              color="green"
                              onClick={async () => {
                                dispatch(clearBlocker());
                                try {

                                  if (blocker && typeof blocker.proceed === "function") {
                                    blocker.proceed();
                                  }
                                } catch (error) {
                                  console.error("Error saving data:", error);
                                }
                              }}
                            >
                              {t("mainButtons.save")}
                            </ModalButton>
                          </div>
                        </div>
                      </div>

                    </Form>
                  );
                }}
              </Formik>
            </>
          }
          customContent={
            <>
            </>
          }
        />
      ) : null}
      <ModalComponent
        isOpen={!!(failedModal && failedModal.length > 0)}
        onClose={onModalClose}
        headerContent={
          <h1 className="h__modal">{t("documentNotification.notification")}</h1>
        }
        content={
          <p className="p__modal ">
            У следующих документов обнаружен неправильный статус:
            <ul>
              {failedModal?.map((item, index) => (
                <li key={index} className="underline-offset-4">{item}</li>
              ))}
            </ul>

          </p>
        }
        customContent={
          <div className="flex flex-row gap-[10px]">
            <ModalButton
              type="button"
              color="grey"
              onClick={() => {
                setFailedModal([])
              }}
            >
              {t("mainButtons.continue")}
            </ModalButton>

          </div>
        }
      />
      <ModalComponent
        isOpen={checkModal}
        onClose={() => {
          setCheckModal(null);
        }}
        headerContent={
          <h1 className="h__modal">
            Чек
          </h1>
        }
        content={
          <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
            {JSON.stringify(checkModal, null, 2)}
          </pre>
        }
        customContent={

          <ModalButton
            type="button"
            color='green'
            onClick={() => {
              setCheckModal(null);
            }}
          >
            Принять
          </ModalButton>
        }
      />

      <ModalComponent
        isOpen={errorModal
          // && !errorModal.singleError
        }
        onClose={() => {
          setErrorModal(null);
        }}
        headerContent={
          <h1 className="h__modal">
            {t("documentNotification.notification")}
          </h1>
        }
        content={
          //   <div className="error-list">
          //   <ul>
          //     {errorModal && errorModal?.length > 0 ? (
          //       errorModal.map((error: any, index: any) => (
          //         <li className="border-b border-gray-300 py-1" key={index}>
          //           {t(`error_dictionary.${error}`)}
          //         </li>
          //       ))
          //     ) : (
          //       <li>{t("documentNotification.no_errors")}</li>
          //     )}
          //   </ul>
          // </div>

          <div className="error-list">
            <ul>
              {Array.isArray(errorModal) && errorModal.length > 0 ? (
                errorModal.map((error: any, index: number) => {
                  console.log("Error data:", error);

                  // Если error — это объект, извлекаем ключи или значения
                  const errorText = typeof error === "object" ? JSON.stringify(error) : error;

                  return (
                    <li className="border-b border-gray-300 py-1" key={index}>
                      Ошибка:  {t(`error_dictionary.${errorText}`)}
                    </li>
                  );
                })
              ) : typeof errorModal === "object" && errorModal !== null ? (
                // Обработка случая, когда errorModal является объектом
                errorModal.errorMessage ? (
                  <li className="border-b border-gray-300 py-1">
                    {t('documentStatus.error')}: {errorModal.errorMessage}
                  </li>
                ) : (
                  <li>{t("documentNotification.no_errors")}</li>
                )
              ) : (
                <li>{t("documentNotification.no_errors")}</li>
              )}
            </ul>
          </div>
        }
        customContent={
          <ModalButton
            type="button"
            onClick={() => {
              setErrorModal(null);
            }}
          >
            {t("mainButtons.accept")}
          </ModalButton>
        }
      />
      <AlertBox isOpen={alertOpen} setIsOpen={setAlertOpen} />
    </div>
  );
};

export default OfdList;
